import { get } from "lodash";
import { PAYMENT_STATUS } from "utils/constants";

const toAmount = (value) => {
  const amount = Number(value);
  return Number.isFinite(amount) && amount > 0 ? amount : 0;
};

const decodeBase64Url = (value) => {
  const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
  const remainder = normalized.length % 4;
  const padded =
    remainder === 0 ? normalized : normalized + "=".repeat(4 - remainder);
  return atob(padded);
};

const readJsonObject = (text) => {
  const start = text.indexOf("{");
  if (start < 0) return null;
  let depth = 0;
  for (let index = start; index < text.length; index += 1) {
    const char = text[index];
    if (char === "{") depth += 1;
    if (char === "}") depth -= 1;
    if (depth === 0) {
      try {
        return JSON.parse(text.slice(start, index + 1));
      } catch (_err) {
        return null;
      }
    }
  }
  return null;
};

const readPaymentFormAmount = (token) => {
  if (typeof token !== "string" || !token) return 0;
  const marker = token.indexOf("eyJ");
  if (marker < 0) return 0;
  let decoded = "";
  try {
    decoded = decodeBase64Url(token.slice(marker));
  } catch (_err) {
    return 0;
  }
  const payload = readJsonObject(decoded);
  const cents = Number(payload && payload.amount);
  if (!Number.isFinite(cents) || cents <= 0) return 0;
  return Math.round(cents) / 100;
};

const quoteBelongsToPlan = (project, insurancePlanId) => {
  if (!insurancePlanId) return false;
  const selectedPlan = get(project, "fields.selectedPlan");
  if (!selectedPlan) return true;
  return selectedPlan === insurancePlanId;
};

export const resolveStoredPlanPremium = ({ project, insurancePlanId }) => {
  const stored = (get(project, "generalCosts") || []).find(
    (generalCost) =>
      insurancePlanId &&
      get(generalCost, "insurancePlan.id") === insurancePlanId,
  );
  const storedAmount = toAmount(get(stored, "cost"));
  if (storedAmount > 0) {
    return {
      amount: storedAmount,
      currency: get(stored, "currency") || "EUR",
    };
  }

  if (!quoteBelongsToPlan(project, insurancePlanId)) return null;

  const quoted = toAmount(get(project, "fields.quotedPremium"));
  if (quoted > 0) return { amount: quoted, currency: "EUR" };

  if (get(project, "fields.paymentStatus") !== PAYMENT_STATUS.PAID) {
    return null;
  }
  const paid = readPaymentFormAmount(get(project, "fields.paymentFormToken"));
  if (paid > 0) return { amount: paid, currency: "EUR" };
  return null;
};
